var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.species.js
// module id = 1299
// module chunks = 1